import script from "./packagesMobileDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./packagesMobileDropdown.vue?vue&type=script&setup=true&lang=js"

import "./packagesMobileDropdown.vue?vue&type=style&index=0&id=4e02bf3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e02bf3c"]])

export default __exports__